import { render, staticRenderFns } from "./makeMethodTypeManage.vue?vue&type=template&id=05af54f5&scoped=true"
import script from "./makeMethodTypeManage.vue?vue&type=script&lang=js"
export * from "./makeMethodTypeManage.vue?vue&type=script&lang=js"
import style0 from "./makeMethodTypeManage.vue?vue&type=style&index=0&id=05af54f5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af54f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05af54f5')) {
      api.createRecord('05af54f5', component.options)
    } else {
      api.reload('05af54f5', component.options)
    }
    module.hot.accept("./makeMethodTypeManage.vue?vue&type=template&id=05af54f5&scoped=true", function () {
      api.rerender('05af54f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/makeMethodTypeManage.vue"
export default component.exports